import { Injectable } from '@angular/core';

import { EMPTY, Observable } from 'rxjs';
import { AbstractApiService } from '../../shared/services';
import { UserRoleService } from '../../shared/services/user-role.service';
import { ProofOfDestruction } from '../models';

@Injectable({
  providedIn: 'root'
})
export class ProofsOfDestructionService {
  constructor(
    private apiService: AbstractApiService,
    private rolesService: UserRoleService
  ) {}

  readProofOfDestruction(iri: string): Observable<any> {
    return this.rolesService.userHasRoleFilter<any>(
      'ROLE_MWS_PROOF_OF_DESTRUCTION_VIEW',
      hasRole =>
        hasRole === false ? EMPTY : this.apiService.getObject(iri, true)
    );
  }

  readProofsOfDestruction(): Observable<any> {
    return this.rolesService.userHasRoleFilter<any>(
      'ROLE_MWS_PROOF_OF_DESTRUCTION_LIST',
      hasRole =>
        hasRole === false
          ? EMPTY
          : this.apiService.getObject('/proofs_of_destruction')
    );
  }

  updateProofOfDestruction(
    iri: string,
    payload: ProofOfDestruction
  ): Observable<any> {
    return this.rolesService.userHasRoleFilter<any>(
      'ROLE_MWS_PROOF_OF_DESTRUCTION_EDIT',
      hasRole =>
        hasRole === false
          ? EMPTY
          : this.apiService.updateObject(iri, payload, true)
    );
  }

  deleteProofOfDestruction(iri: string): Observable<any> {
    return this.rolesService.userHasRoleFilter<any>(
      'ROLE_MWS_PROOF_OF_DESTRUCTION_DELETE',
      hasRole =>
        hasRole === false ? EMPTY : this.apiService.deleteObject(iri, true)
    );
  }
}
